export type TPaymentType = typeof SmartpayType;
export const SmartpayType = "SMART_PAY";
